import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Search } from "lucide-react";
import { useState } from "react";

const navLinks = [
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Reviews", path: "/reviews" },
  { name: "Projects", path: "/projects" },
  { name: "Blog", path: "/blog" },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/60 backdrop-blur-xl border-b border-gray-100 text-black">
      <div className="container mx-auto px-6">
        <nav className="flex items-center justify-between h-24">
          <Link 
            to="/" 
            className="flex items-center gap-2"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Usman Ahmad - Home"
          >
            <img 
              src="/logoua.webp" 
              alt="Usman Ahmad Logo - Full-Stack Developer" 
              title="Usman Ahmad - Portfolio"
              className="h-12 w-auto object-contain invert" 
              width="144" 
              height="48"
              loading="eager"
            />
          </Link>

          {}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`nav-link text-xs font-black uppercase tracking-[0.2em] transition-all px-4 py-3 min-h-12 flex items-center rounded focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 outline-none active:scale-95 ${location.pathname === link.path ? "text-black" : "text-gray-600 hover:text-black"
                  }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact" className="ml-4 px-6 py-3 min-h-12 flex items-center justify-center bg-black text-white text-xs uppercase tracking-widest font-black hover:bg-gray-800 transition-all active:scale-95 focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 outline-none rounded">
              Hire Me
            </Link>
          </div>

          {}
          <button
            className="md:hidden text-black p-2 min-h-12 min-w-12 flex items-center justify-center focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 outline-none rounded active:scale-95"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </nav>
      </div>

      {}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 top-24 bg-black/20 backdrop-blur-sm z-30 md:hidden"
            onClick={() => setIsMenuOpen(false)}
          />
        )}
        {isMenuOpen && (
          <motion.div
            key="menu"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-24 left-0 w-full bg-white border-b-2 border-black p-8 md:hidden shadow-2xl z-40"
          >
            <div className="flex flex-col gap-5">
              {navLinks.map((link, index) => (
                <motion.div
                  key={link.name}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                >
                  <Link
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-xl font-black uppercase tracking-tighter text-black hover:pl-2 transition-all duration-300 block py-4 min-h-12 focus-visible:ring-2 focus-visible:ring-black outline-none rounded"
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}

              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.25 }}
              >
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="mt-4 px-6 py-4 min-h-12 flex items-center justify-center bg-black text-white text-xs uppercase tracking-widest font-black hover:bg-gray-800 transition-all text-center active:scale-95 focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 outline-none rounded"
                >
                  Hire Me
                </Link>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;